import React, { useContext, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { FloorPlanPropTypes, FloorPlanDefaultProps } from '../../utils/DrupalEntityTypes/FloorPlan/FloorPlanPropTypes';
import { preloadPhoto } from '../../utils/common';

import FadingContainer from '../FadingContainer/FadingContainer';

import FloorPlanImage from '../FloorPlanImage/FloorPlanImage';
import FloorPlanImagesWidgetButtons from './FloorPlanImagesWidgetButtons';

import './FloorPlanImagesWidget.scss';

const FloorPlanImagesWidget = ( {
  className,
  data,
} ) => {
  const [ activeFloorPlan, setActiveFloorPlan ] = useState( false );
  const [ imageLoaded, setImageLoaded ] = useState( false );

  const {
    uuid,
    title,
    twoD,
    threeD,
    //downloadablePdf,
  } = data

  const threeDSrc = threeD?.modal;
  const twoDSrc = twoD?.modal;

  // Preload floor plan images, so we can fade them in.
  const mountedRef = useRef(true)

  useEffect( () => {
    const preloadFloorPlanImages = async ( firstFP ) => {
      const result = await preloadPhoto( firstFP );
      if (!mountedRef.current) return null;
      else if ( result === 'Success' ) {
        setImageLoaded( true );
      }
      else {
        setImageLoaded( false );
      }
    };
    if ( twoDSrc || threeDSrc ) {
      const firstFP = threeDSrc || twoDSrc;
      if ( firstFP ) {
        preloadFloorPlanImages( firstFP );
      }
    }
  }, [ twoDSrc, threeDSrc ] );

  useEffect(() => {
    return () => {
      mountedRef.current = false
    }
  }, [])

  const disclaimer = 'Renderings are intended as a general reference. Features, finishes, layout, and measurements may vary.';

  // Don't render if there aren't images, unless its the pib because we still
  // need to render the floor plan download button
  return imageLoaded && (
    <FadingContainer>
      <div
        id="floorplan-scroll"
        className={className}
      >

        <div className="floorPlanImagesWidget">

          { ( twoDSrc || threeDSrc ) && (

            <div className="floorPlanImagesWidget__images">

              <FloorPlanImage
                src={threeDSrc}
                imgClassName={classnames(
                  'floorPlanImage__image',
                  { 'floorPlanImage__image--inactive': activeFloorPlan },
                )}
                imgAlt={`3D ${title}`}
                disclaimer={disclaimer}
              />

              <FloorPlanImage
                src={twoDSrc}
                imgClassName={classnames(
                  'floorPlanImage__image',
                  { 'floorPlanImage__image--inactive': !activeFloorPlan && threeDSrc },
                )}
                imgAlt={`2D ${title}`}
                disclaimer={disclaimer}
              />

            </div>
          )}

          {/* We pass all the data to the floor plan widget because
          it has a print link that needs fp data. */}
          <FloorPlanImagesWidgetButtons
            activeFloorPlan={activeFloorPlan}
            setActiveFloorPlan={setActiveFloorPlan}
            data={data}
          />

        </div>

        {( twoDSrc || threeDSrc ) && (
          <div className="floorPlanImagesWidget__disclaimer">
            { disclaimer }
          </div>
        )}

      </div>
    </FadingContainer>
  );
};

FloorPlanImagesWidget.propTypes = {
  className: PropTypes.string,
  data: FloorPlanPropTypes.data,
};

FloorPlanImagesWidget.defaultProps = {
  className: '',
  data: FloorPlanDefaultProps.data,
};

export default FloorPlanImagesWidget;
